<template>
  <div class="dashboard">
    <!-- 头部 -->
    <div class="header">
      <div class="title">
        <h1><i class="fas fa-dice-d20" style="margin-right: 12px; color: #818cf8;"></i>哈希量化 · 大小单双</h1>
        <p>基于波场最新区块哈希尾数 · 无需钱包 模拟交易</p>
      </div>
      <div class="badge">
        <i class="fas fa-link"></i> TRON 主网 · 只读
      </div>
    </div>

    <!-- 当前区块链信息卡片 -->
    <div class="info-panel">
      <div class="info-card block">
        <div class="info-label"><i class="far fa-clock"></i> 当前区块高度</div>
        <div class="info-value">{{ currentBlock || '--' }}</div>
      </div>
      <div class="info-card hash">
        <div class="info-label"><i class="fas fa-hashtag"></i> 区块哈希 (尾数)</div>
        <div class="info-value hash-value">
          <span v-if="currentHash">{{ shortHash }}<span class="last-digit">{{ lastDigit }}</span></span>
          <span v-else>--</span>
        </div>
      </div>
      <div class="info-card size">
        <div class="info-label"><i class="fas fa-arrows-alt-h"></i> 大小结果</div>
        <div class="info-value">
          {{ sizeResult || '?' }}
          <span class="result-badge size-badge" v-if="sizeResult === '大'">⚡ 大</span>
          <span class="result-badge size-badge" v-else-if="sizeResult === '小'">💧 小</span>
        </div>
      </div>
      <div class="info-card parity">
        <div class="info-label"><i class="fas fa-divide"></i> 单双结果</div>
        <div class="info-value">
          {{ parityResult || '?' }}
          <span class="result-badge parity-badge" v-if="parityResult === '单'">🎲 单</span>
          <span class="result-badge parity-badge" v-else-if="parityResult === '双'">🎯 双</span>
        </div>
      </div>
    </div>

    <!-- 交易控制区 -->
    <div class="trade-panel">
      <div class="balance-area">
        <div class="balance-box">
          <i class="fas fa-coins" style="color: #fbbf24;"></i>
          <span class="balance-amount">{{ balance.toFixed(0) }}</span> USDT
        </div>
        <button class="reset-btn" @click="resetBalance"><i class="fas fa-undo-alt"></i> 重置余额</button>
      </div>

      <div class="bet-controls">
        <!-- 投注金额 -->
        <div class="input-group">
          <label><i class="fas fa-hand-holding-usd"></i> 投注金额</label>
          <input type="number" v-model.number="betAmount" min="1" :max="balance" class="amount-input" step="1">
        </div>

        <!-- 大小单双选项 -->
        <div class="bet-options">
          <button class="bet-btn big" :class="{ active: selectedBet === '大' }" @click="selectedBet = '大'">大</button>
          <button class="bet-btn small" :class="{ active: selectedBet === '小' }" @click="selectedBet = '小'">小</button>
          <button class="bet-btn odd" :class="{ active: selectedBet === '单' }" @click="selectedBet = '单'">单</button>
          <button class="bet-btn even" :class="{ active: selectedBet === '双' }" @click="selectedBet = '双'">双</button>
        </div>

        <!-- 自动投注按钮 -->
        <div class="action-btns">
          <button class="action-btn" :class="{ warning: autoBetting }" @click="toggleAutoBet" :disabled="loading">
            <i class="fas" :class="autoBetting ? 'fa-stop-circle' : 'fa-play-circle'"></i>
            {{ autoBetting ? '停止自动' : '自动量化' }}
          </button>
          <button class="action-btn secondary" @click="clearBetHistory" :disabled="loading || betHistory.length === 0">
            <i class="fas fa-trash"></i> 清除记录
          </button>
        </div>
      </div>

      <!-- 错误提示 -->
      <div v-if="error" class="error-banner">
        <i class="fas fa-exclamation-triangle"></i> {{ error }}
      </div>
    </div>

    <!-- 历史记录与统计 -->
    <div class="history-section">
      <div class="section-title">
        <i class="fas fa-history"></i> 投注记录
        <router-link :to="{ path: '/history', query: { block: currentBlock } }" class="history-link">
          <i class="fas fa-list"></i> 查看全部
        </router-link>
        <div class="stats">
          <span><i class="far fa-chart-bar"></i> 总手: {{ totalBets }}</span>
          <span><i class="fas fa-percent"></i> 胜率: {{ winRate }}%</span>
          <span><i class="fas fa-chart-line"></i> 净利: {{ netProfit }}</span>
        </div>
      </div>
      <div class="history-list" v-if="betHistory.length">
        <div v-for="(item, idx) in betHistory.slice(0, 5)" :key="idx" class="history-item" :class="item.result === '赢' ? 'win' : 'loss'">
          <span class="history-block">#{{ item.block }}</span>
          <span class="history-bet">{{ item.bet }} {{ item.amount }}</span>
          <span>哈希尾 {{ item.lastDigit }} → {{ item.size }}/{{ item.parity }}</span>
          <span class="history-profit" :class="item.profit > 0 ? 'profit-positive' : 'profit-negative'">
            {{ item.profit > 0 ? '+' : '' }}{{ item.profit }}
          </span>
          <span style="font-size:0.8rem; color:#7e8aaf;">{{ item.time }}</span>
        </div>
      </div>
      <div v-else style="text-align:center; padding:30px; color:#5f6b96;">
        <i class="fas fa-inbox fa-2x"></i>
        <p>暂无投注记录，点击「自动量化」开始</p>
      </div>
    </div>
    <div class="footer-note">
      <i class="fas fa-shield-alt"></i> 量化模拟 · 每次投注基于最新区块哈希尾数 (0-9,a-f) 大(8-f)小(0-7) 单(奇)双(偶)
    </div>
  </div>
</template>

<script>
import { fetchBlock } from '../api/tron'

export default {
  name: 'HomePage',
  data() {
    return {
      // 区块链数据
      currentBlock: null,
      currentHash: null,
      lastDigit: null,
      sizeResult: null,
      parityResult: null,
      // 投注相关
      balance: 10000,
      betAmount: 10,
      baseBetAmount: 10, // 基础投注金额
      selectedBet: '大',      // 可选 '大' '小' '单' '双'
      betHistory: [],
      // 自动投注
      autoBetting: false,
      intervalId: null,
      // 投注规则配置
      betRules: {
        baseBetAmount: 10,
        multiplier: 2,
        maxBetAmount: 1000,
        autoBetInterval: 5,
        enableReverseBet: true
      },
      // UI 状态
      loading: false,
      error: null,
    }
  },
  computed: {
    shortHash() {
      if (!this.currentHash) return '';
      return this.currentHash.slice(0, 10) + '…' + this.currentHash.slice(-6);
    },
    totalBets() {
      return this.betHistory.length;
    },
    winRate() {
      if (this.totalBets === 0) return 0;
      const wins = this.betHistory.filter(h => h.result === '赢').length;
      return ((wins / this.totalBets) * 100).toFixed(1);
    },
    netProfit() {
      return this.betHistory.reduce((acc, cur) => acc + cur.profit, 0);
    }
  },
  async mounted() {
    // 加载投注规则配置
    this.loadBetRules();
    // 加载历史记录
    this.loadBetHistory();
    // 加载自动投注状态
    this.loadAutoBetStatus();
    // 立即获取一次区块
    await this.fetchBlockData();
    // 如果之前是自动投注状态，则恢复自动投注
    if (this.autoBetting) {
      this.resumeAutoBet();
    }
  },
  beforeDestroy() {
    // 保存自动投注状态到本地存储
    localStorage.setItem('autoBetStatus', JSON.stringify({
      autoBetting: this.autoBetting,
      betAmount: this.betAmount,
      selectedBet: this.selectedBet
    }));
    // 清除定时器，避免内存泄漏
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  methods: {
    // 恢复自动投注状态
    resumeAutoBet() {
      if (this.balance < this.betAmount) {
        this.autoBetting = false;
        localStorage.setItem('autoBetStatus', JSON.stringify({
          autoBetting: false,
          betAmount: this.betAmount,
          selectedBet: this.selectedBet
        }));
        return;
      }
      // 清除之前的定时器（如果存在）
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      // 先立即执行一次投注（基于当前区块）
      this.autoBetAction();
      // 设置定时器，使用配置的间隔时间
      this.intervalId = setInterval(() => {
        this.autoBetAction();
      }, this.betRules.autoBetInterval * 1000);
    },
    // 加载历史记录
    loadBetHistory() {
      const history = localStorage.getItem('betHistory');
      if (history) {
        this.betHistory = JSON.parse(history);
      }
    },
    // 加载自动投注状态
    loadAutoBetStatus() {
      const status = localStorage.getItem('autoBetStatus');
      if (status) {
        const savedStatus = JSON.parse(status);
        this.autoBetting = savedStatus.autoBetting || false;
        this.betAmount = savedStatus.betAmount || this.betRules.baseBetAmount;
        this.selectedBet = savedStatus.selectedBet || '大';
      }
    },
    // 加载投注规则配置
    loadBetRules() {
      const settings = localStorage.getItem('appSettings');
      if (settings) {
        const savedSettings = JSON.parse(settings);
        if (savedSettings.betRules) {
          this.betRules = {
            baseBetAmount: savedSettings.betRules.baseBetAmount || 10,
            multiplier: savedSettings.betRules.multiplier || 2,
            maxBetAmount: savedSettings.betRules.maxBetAmount || 1000,
            autoBetInterval: savedSettings.betRules.autoBetInterval || 5,
            enableReverseBet: savedSettings.betRules.enableReverseBet !== undefined ? savedSettings.betRules.enableReverseBet : true
          };
          this.baseBetAmount = this.betRules.baseBetAmount;
          this.betAmount = this.betRules.baseBetAmount;
        }
      }
    },
    // 获取最新区块并解析哈希尾数
    async fetchBlockData() {
      this.loading = true;
      this.error = null;
      try {
        const blockData = await fetchBlock();
        this.currentBlock = blockData.blockNumber;
        this.currentHash = blockData.blockHash;
        this.lastDigit = blockData.lastDigit;
        this.sizeResult = blockData.sizeResult;
        this.parityResult = blockData.parityResult;
      } catch (err) {
        this.error = '获取区块失败: ' + err.message;
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    // 手动投注
    manualBet() {
      // 开始投注前清空历史记录
      if (this.betHistory.length > 0) {
        this.betHistory = [];
        localStorage.setItem('betHistory', JSON.stringify(this.betHistory));
      }
      this.placeBet(false);
    },
    // 核心投注逻辑
    placeBet(isAuto = false) {
      // 校验余额
      if (this.balance < this.betAmount) {
        alert('余额不足');
        if (isAuto) this.stopAutoBet();
        return;
      }
      // 必须有有效结果
      if (!this.sizeResult || !this.parityResult) {
        alert('尚未获取区块结果');
        return;
      }

      // 判断输赢
      let win = false;
      if (this.selectedBet === '大' || this.selectedBet === '小') {
        win = (this.selectedBet === this.sizeResult);
      } else { // 单双
        win = (this.selectedBet === this.parityResult);
      }

      // 记录历史
      const record = {
        block: this.currentBlock,
        hash: this.currentHash,
        lastDigit: this.lastDigit,
        bet: this.selectedBet,
        amount: this.betAmount,
        result: win ? '赢' : '输',
        size: this.sizeResult,
        parity: this.parityResult,
        time: new Date().toLocaleTimeString('zh-CN', { hour12: false }),
        profit: win ? this.betAmount : -this.betAmount
      };

      // 更新余额
      if (win) {
        this.balance += this.betAmount;
        // 赢了，做反投（如果启用）
        if (this.betRules.enableReverseBet) {
          this.switchBet();
        }
        // 重置投注金额为基础金额
        this.betAmount = this.betRules.baseBetAmount;
      } else {
        this.balance -= this.betAmount;
        // 输了，做倍投
        this.betAmount *= this.betRules.multiplier;
        // 应用最大投注金额限制
        if (this.betAmount > this.betRules.maxBetAmount) {
          this.betAmount = this.betRules.maxBetAmount;
        }
      }

      // 插入历史（最新在上）
      this.betHistory.unshift(record);

      // 保存历史记录到本地存储
      localStorage.setItem('betHistory', JSON.stringify(this.betHistory));

      // 如果自动投注开启且余额不足以进行下一次，则停止自动
      if (isAuto && this.balance < this.betAmount) {
        this.stopAutoBet();
        alert('余额不足，自动投注已停止');
      }
    },
    // 切换投注方向（反投）
    switchBet() {
      if (this.selectedBet === '大') {
        this.selectedBet = '小';
      } else if (this.selectedBet === '小') {
        this.selectedBet = '大';
      } else if (this.selectedBet === '单') {
        this.selectedBet = '双';
      } else if (this.selectedBet === '双') {
        this.selectedBet = '单';
      }
    },
    // 自动投控制
    startAutoBet() {
      if (this.balance < this.betAmount) {
        alert('余额不足，无法开启自动');
        return;
      }
      // 开始自动投注前清空历史记录
      if (this.betHistory.length > 0) {
        this.betHistory = [];
        localStorage.setItem('betHistory', JSON.stringify(this.betHistory));
      }
      this.autoBetting = true;
      // 清除之前的定时器（如果存在）
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      // 先立即执行一次投注（基于当前区块）
      this.autoBetAction();
      // 设置定时器，使用配置的间隔时间
      this.intervalId = setInterval(() => {
        this.autoBetAction();
      }, this.betRules.autoBetInterval * 1000);
    },
    stopAutoBet() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
    this.autoBetting = false;
  },
  toggleAutoBet() {
      if (this.autoBetting) {
        this.stopAutoBet();
      } else {
        this.startAutoBet();
      }
    },
    // 自动投单次动作: 刷新区块，然后投注
    async autoBetAction() {
      if (this.balance < this.betAmount) {
        this.stopAutoBet();
        alert('余额不足，自动停止');
        return;
      }
      // 先获取最新区块
      await this.fetchBlockData();
      // 再次检查余额（防止fetch期间余额被其他操作改变，但这里没有并发）
      if (this.balance >= this.betAmount) {
        this.placeBet(true);
      } else {
        this.stopAutoBet();
      }
    },
    // 重置余额到10000
    resetBalance() {
      this.balance = 10000;
      // 可选清空历史？这里保留历史，只重置金额
    },
    // 清除投注记录
    clearBetHistory() {
      if (confirm('确定要清除所有投注记录吗？')) {
        this.betHistory = [];
        localStorage.setItem('betHistory', JSON.stringify(this.betHistory));
      }
    }
  },
  watch: {
    // 如果余额变为0且自动开启，停止自动
    balance(newVal) {
      if (newVal < this.betAmount && this.autoBetting) {
        this.stopAutoBet();
        alert('余额不足，自动投注已停止');
      }
    }
  }
}
</script>

<style scoped>
.history-link {
  color: #818cf8;
  text-decoration: none;
  margin-left: auto;
  margin-right: 20px;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 5px;
  background: #262e4f;
  padding: 6px 16px;
  border-radius: 30px;
  border: 1px solid #3f4a7a;
  transition: 0.2s;
}

.history-link:hover {
  background: #334155;
  color: #a5b4fc;
}
.action-btn.secondary {
  background: #7f1d1d;
  border-color: #f87171;
  color: #fecaca;
}

.action-btn.secondary:hover {
  background: #991b1b;
  box-shadow: 0 0 15px #7f1d1d;
}
</style>